// 设置数据
import * as types from "./mutations-types";

const mutations = {
  [types.SET_NAV_INFO](state, data) {
    console.log(data, "22222");
    state.navInfo = data;
  },
  [types.SET_USER_INFO](state, data) {
    state.userInfo = data;
  },
  [types.SET_ROOT_ID_INFO](state, data) {
    state.rootId = data;
  },
  //消息红点
  [types.SET_SHOW_HIDDEN](state, data) {
    state.showhidden = data;
  },
  [types.SET_ROLERS_SOURCEINFO](state, data) {
    state.userroleresourceList = data;
  },
  [types.SET_MEMBER_INFO](state, data) {
    state.memberInfo = data || {};
  },
  SET_ISROUTEFATAREADY(state, data) {
    state.isRouteDataReady = data;
  },
};

export default mutations;
